import React from 'react';
export function Disclaimer() {
  return <div className="text-xs text-gray-500" data-id="element-373">
      <p className="mb-2" data-id="element-374">
        Allmän information. Kosttillskott ersätter inte en varierad kost.
        Resultat varierar från person till person. Uttalanden har inte
        utvärderats av Läkemedelsverket.
      </p>
      <p className="text-[0.6rem]" data-id="element-375">
        *Studien genomfördes på en liten grupp individer och resultaten
        representerar inte nödvändigtvis den genomsnittliga användarens
        erfarenhet. Individuella resultat kan variera avsevärt.
      </p>
    </div>;
}